import { z } from "zod";
import { messageNodeFieldSchema } from "./fields";

export const messageNodeSchema = z.object({
  nodeId: z.string(),
  fields: z.array(messageNodeFieldSchema),
  isValid: z.boolean().default(true),
});

export type MessageNodeSchema = z.infer<typeof messageNodeSchema>;

export const defaultMessageNodeValues: MessageNodeSchema = {
  nodeId: "",
  fields: [],
  isValid: true,
};
